
<div class="layout-container">
    <nz-layout>
        <nz-sider  *ngIf="debugging == null || debugging.idjob==null"
            [nzCollapsible]="true"
            [nzCollapsed]="collapsedToolBar"
            [nzWidth]="255"
            nzTheme="light"
            (nzCollapsedChange)="onCollapseToolBar($event)"
            
           
            >

            <div class="sider-scroll">
                <webhook-toolbox></webhook-toolbox>
            </div>
        </nz-sider>

        <nz-content class="content-layout">

            <nz-alert nzBanner nzMessage="{{'workflow.version.message'|translateTA:{version:flowData.sequence,data:selectedVersion!.lastChange} }}" *ngIf="flowData.status=='DRAFT' && selectedVersion!=null" [nzAction]="actionSave"></nz-alert>
            <nz-alert nzBanner nzType="error" nzMessage="{{'workflow.version.message.deprecated'|translateTA:{version:flowData.sequence} }}" *ngIf="flowData.status=='DEPRECATED'"></nz-alert>

            <ng-template #actionSave>
                <button *ngIf="canSave" nz-button nzSize="small" nzType="primary" (click)="saveFlow(false)">{{'save'|translateTA}}</button>
                <!--nz-divider nzType="vertical"></nz-divider>
                <button *ngIf="canSave" nz-button nzSize="small" nzType="primary"  nzDanger  (click)="undo()">{{'undo'|translateTA}}</button-->
            </ng-template>

            <div class="main">
                
                
                <!--nz-float-button   nz-tooltip  [nzTooltipTitle]="'workflow.assistant'|translateTA" (click)="openAIAssistant()" >
                    <img src="assets/image/ia.gif" alt="gif icon" style="width: 40px; height: 40px;"  />
                </nz-float-button-->

                <button nz-button class="ia-float-button"  nz-tooltip  [nzTooltipTitle]="'workflow.assistant'|translateTA" (click)="openAIAssistant()" >
                    <img src="assets/image/ia.png" alt="loading"  class="gif-icon"/>
                </button>




                <div class="flow-loading" *ngIf="flowLoading">
                    <nz-spin nzSize="large" nzSimple></nz-spin>
                </div>
                <div class="canvas-container" [ngClass]="debugging != null && debugging.idjob!=null?'debugging':''">
                    <webhook-debug-toolbar [flowData]="flowData" (actionPerformed)="debugBoxAction($event)" class="workflow-debug-toolbar" *ngIf="debug" ></webhook-debug-toolbar>
                
                    
                    <f-flow 
                    *ngIf="!reloadingFlow"
                    fDraggable (fLoaded)="onLoaded()"  #flowRef
                    (fCreateConnection)="addConnection($event)"
                    (fReassignConnection)="reassignConnection($event)"
                    (fCreateNode)="addNode($event)"
                    (fDropToGroup)="dropToGroup($event)"
                    (fSelectionChange)="onSelectionChange($event)"
                    [fDraggableDisabled]="selectedVersion!= null && selectedVersion.status!= 'DRAFT'"
                    (fDragEnded)="onDragEnded($event)"
                    >
                    <f-selection-area></f-selection-area>
                    <f-background>
                        <f-rect-pattern></f-rect-pattern>
                    </f-background>
                    <f-line-alignment [fAlignThreshold]="10"></f-line-alignment>
                        <f-canvas  [fZoom]="isZoomEnabled">
                            <f-connection-for-create [fBehavior]="cBehavior"
                                        [fType]="cType">
                                <!-- <svg viewBox="0 0 10 10" fMarker [type]="eMarkerType.START" [height]="10" [width]="10" [refX]="5" [refY]="5">
                                    <circle cx="5" cy="5" r="2" stroke="none"></circle>
                                </svg>
                                <svg viewBox="0 0 6 6" fMarker [type]="eMarkerType.END" [height]="6" [width]="6" [refX]="5" [refY]="3">
                                    <path d="M0,0 L6,3 0,6Z" stroke="none"></path>
                                </svg> -->
                                <!-- <svg viewBox="0 0 700 700" fMarker [type]="eMarkerType.START" class="connection-marker"
                                    [height]="5" [width]="5"
                                    [refX]="2.5" [refY]="2.5" markerUnits="strokeWidth">
                                    <circle cx="350" cy="350" r="350"/>
                                </svg>
                                <svg viewBox="0 0 6 7" fMarker [type]="eMarkerType.END" class="connection-marker"
                                    [height]="7" [width]="6"
                                    [refX]="5.5" [refY]="3.5" markerUnits="strokeWidth" orient="auto">
                                    <path d="M0.000391006 0L6 3.5L0.000391006 7L0.000391006 0Z"/>
                                </svg> -->

                            </f-connection-for-create>
                            <!-- <f-snap-connection [fBehavior]="cBehavior"
                                [fType]="cType" [fSnapThreshold]="100">
                                    <svg viewBox="0 0 10 10" fMarker [type]="eMarkerType.START" [height]="10" [width]="10" [refX]="5" [refY]="5">
                                        <circle cx="5" cy="5" r="2" stroke="none"></circle>
                                    </svg>
                                    <svg viewBox="0 0 6 6" fMarker [type]="eMarkerType.END" [height]="6" [width]="6" [refX]="5" [refY]="3">
                                        <path d="M0,0 L6,3 0,6Z" stroke="none"></path>
                                    </svg>
                            </f-snap-connection> -->
                            @for (connection of connections; track connection.key) {

                                <f-connection [fBehavior]="cBehavior"
                                        data-nozoom="true"
                                        (dblclick)="openConnectionConfiguration($event,connection)"
                                        [fConnectionId]="connection.key"
                                        [fType]="cType"
                                        [fReassignDisabled]="true"
                                        [fTextStartOffset]="fTextStartOffset" [fText]="getConnectionName(connection.key)|translateTA"
                                        [fOutputId]="connection.from" [fInputId]="connection.to">
                                            <!-- <svg viewBox="0 0 10 10" fMarker [type]="eMarkerType.START" [height]="10" [width]="10" [refX]="5" [refY]="5">
                                                <circle cx="5" cy="5" r="2" stroke="none"></circle>
                                            </svg>
                                            <svg viewBox="0 0 6 6" fMarker [type]="eMarkerType.END" [height]="6" [width]="6" [refX]="5" [refY]="3">
                                                <path d="M0,0 L6,3 0,6Z" stroke="none"></path>
                                            </svg>
                                            <svg viewBox="0 0 10 10" fMarker [type]="eMarkerType.SELECTED_START" [height]="10" [width]="10" [refX]="5" [refY]="5">
                                                <circle cx="5" cy="5" r="2" stroke="none"></circle>
                                            </svg>
                                            <svg viewBox="0 0 6 6" fMarker [type]="eMarkerType.SELECTED_END" [height]="6" [width]="6" [refX]="5" [refY]="3">
                                                <path d="M0,0 L6,3 0,6Z" stroke="none"></path>
                                            </svg> -->
                                            <!-- <svg viewBox="0 0 700 700" fMarker [type]="eMarkerType.START" class="connection-marker"
                                                    [height]="5" [width]="5"
                                                    [refX]="2.5" [refY]="2.5" markerUnits="strokeWidth">
                                                <circle cx="350" cy="350" r="350"/>
                                            </svg>
                                            <svg viewBox="0 0 6 7" fMarker [type]="eMarkerType.END" class="connection-marker"
                                                    [height]="7" [width]="6"
                                                    [refX]="5.5" [refY]="3.5" markerUnits="strokeWidth" orient="auto">
                                                <path d="M0.000391006 0L6 3.5L0.000391006 7L0.000391006 0Z"/>
                                            </svg> -->
                                </f-connection>
                            
                            }
                            @for (node of nodes; track node.key) {
                                <webhook-edit-node-if fNode
                                        
                                        (dblclick)="editNodeConfiguration(node,false)"
                                        [node]="node" 
                                        [fNodeId]="node.key" 
                                        [fNodePosition]="node.position" 
                                        [fNodeSize]="node.size"
                                        [fNodeParentId]="node.parentId"
                                        [color]="node.color"
                                        [selectedVersion]="selectedVersion"
                                        [debug]="debug"
                                        [debugging]="lastDebugging"
                                        (fNodePositionChange)="onPositionChange($event,node)"
                                        (fNodeSizeChange)="onSizeChange($event,node)"
                                        *ngIf="node.type == 'IF'"
                                        [ngClass]="'wh-node-if' + ' ' +getExecutionDebug(node)"
                                ></webhook-edit-node-if>
                            }
                            @for (node of nodes; track node.key) {
                                <webhook-node fNode  
                                        (dblclick)="editNodeConfiguration(node,false)"
                                        [node]="node" 
                                        [fNodeId]="node.key" 
                                        [fNodePosition]="node.position" 
                                        [fNodeSize]="node.size"
                                        [fNodeParentId]="node.parentId"
                                        [fIncludePadding]="true"
                                        [color]="node.color"
                                        [selectedVersion]="selectedVersion"
                                        *ngIf="node.type != 'IF'"
                                        [debug]="debug"
                                        [debugging]="lastDebugging"
                                        (fNodePositionChange)="onPositionChange($event,node)"
                                        (fNodeSizeChange)="onSizeChange($event,node)"
                                        

                                        [ngClass]="(node.type == 'WHILE' || node.type == 'FOREACH' ? 'wh-node-group' : '') + ' ' +getExecutionDebug(node)"
                                ></webhook-node>
                            }
                        
                        </f-canvas>
                    </f-flow>

                    <div class="zoom-toolbar">
                        <button nz-button nzType="default" nzSize="small" (click)="onZoomIn()" nz-tooltip nzTooltipTitle="{{'zoomin' |translateTA}}">
                                <nz-icon nzType="zoom-in" />
                        </button>
                        <button nz-button nzType="default" nzSize="small" (click)="onZoomOut()" nz-tooltip nzTooltipTitle="{{'zoomout' |translateTA}}">
                                <nz-icon nzType="zoom-out" />
                        </button>
                        <!--f-checkbox [checked]="isZoomEnabled" (change)="onZoomOnMouseWheelChanged($event)">Enable Wheel and Dbl Click</f-checkbox-->
                    </div>
                </div>
            </div>
            <div class="version-selector" *ngIf="listOfVersion.length > 0" >
                <nz-select [(ngModel)]="selectedVersion" nzShowSearch  [nzCustomTemplate]="selectedValueTemplate"  (ngModelChange)="onVersionChange($event)">
                    <nz-option  [nzValue]="option"  nzCustomContent  *ngFor="let option of listOfVersion" >
                        @let dataOption = getLabel(option);
                        <span [style.color]="dataOption.color" nz-tooltip  [nzTooltipTitle]="dataOption.name"  [nzTooltipArrowPointAtCenter]="true">
                            {{ dataOption.label }}
                        </span>
                    </nz-option>
                </nz-select>
            </div>
            <webhook-edit-toolbar (actionPerformed)="toolBoxAction($event)" [selectedVersion]="selectedVersion"></webhook-edit-toolbar>
            <ng-template #selectedValueTemplate let-selected>
                @let dataOption = getLabel(selected.nzValue);
            <span [style.color]="dataOption.color" [style.fontWeight]="500" nz-tooltip  [nzTooltipTitle]="dataOption.name"  [nzTooltipArrowPointAtCenter]="true">{{dataOption.label}}</span>
            </ng-template>
            <ng-template #footerTpl>
                <div style="float: right">
                    <button nz-button style="margin-right: 8px;" (click)="close()">{{'cancel'|translateTA}}</button>
                    <button nz-button nzType="primary" (click)="save()">{{'save'|translateTA}}</button>
                </div>
            </ng-template>
            <ng-template #copyInput let-data let-modalRef="modalRef">
                <input nz-input placeholder="{{'workflow.input.copy.name'|translateTA}}" [(ngModel)]="data.flowData.name" type="text" />
            </ng-template>

            


        </nz-content>
    </nz-layout>


</div>

<input type="file" #fileUpload accept=".json, application/json" (change)="onFileSelected($event)" hidden/>


